// 8.3.7 — learner level control (merged into the locale as `lvl`).
const lvl = {
  "changeLevel": "Cambiar nivel",
  "title": "Cambia tu nivel de {lang}",
  "help": "Elige el nivel que mejor te encaje. Puedes cambiarlo cuando quieras.",
  "safe": "No perderás tus palabras guardadas, tus repasos ni tu progreso.",
  "save": "Guardar nivel",
  "cancel": "Cancelar",
  "saving": "Guardando…",
  "changed": "Nivel cambiado a {level}. Tu práctica se adaptará a tu nuevo nivel a partir de ahora.",
  "failed": "No se pudo cambiar tu nivel. Inténtalo de nuevo.",
  "current": "Actual",
  "profilesHelp": "Tu perfil de idioma y su nivel MCER. Cambiar el nivel solo afecta a la práctica futura.",
  "levels": {
    "A1": {
      "name": "Principiante",
      "desc": "Palabras básicas y frases sencillas del día a día."
    },
    "A2": {
      "name": "Elemental",
      "desc": "Situaciones conocidas y conversaciones breves."
    },
    "B1": {
      "name": "Intermedio",
      "desc": "Te desenvuelves en conversaciones cotidianas con cada vez más soltura."
    },
    "B2": {
      "name": "Intermedio alto",
      "desc": "Hablas de muchos temas con naturalidad y entiendes un lenguaje más complejo."
    },
    "C1": {
      "name": "Avanzado",
      "desc": "Expresas tus ideas con fluidez y manejas los matices del idioma."
    },
    "C2": {
      "name": "Maestría",
      "desc": "Entiendes y expresas casi cualquier cosa con precisión."
    }
  }
};
export default lvl;
